type ChangeUserDataResponse = {
    state: string,
    city: string,
    neighborhood: string
    street: string,
    service: string
}

export const fetchCEP = async (cep: any) => {
  const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`);

  if (!response.ok) {
    return response.status
  }

  return await response.json() as ChangeUserDataResponse;
};
